import React from 'react';
import { Text } from '@components/typography';
import { JoykitColor } from '@components/themes';
import { ChevronRightIcon } from '@images/ChevronRight';
import {
  TestimonialContainer,
  TestimonialDetails,
  TestimonialAsset,
  TitleWrapper,
  StyledQuotesContainer,
  DetailWrapper,
  TestimonialContent,
  StyledReadMore,
} from './TestimonialCarouselItem.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

type TestimonialType = {
  title: string;
  author: string;
  imagePath: string;
  readMoreContent?: string;
};

type TestimonialCarouselItemProps = {
  testimonialData: TestimonialType;
  backgroundColor?: JoykitColor;
  isExpanded?: boolean;
  toggleExpanded?: () => void;
};

export const TestimonialCarouselItem: React.FC<TestimonialCarouselItemProps> = (props) => {
  const { testimonialData, toggleExpanded, isExpanded = false, backgroundColor = 'blue6' } = props;
  const { t } = useTranslation('testimonials');

  return (
    <TestimonialContainer backgroundColor={backgroundColor}>
      <DetailWrapper>
        <TestimonialDetails>
          <TestimonialContent isExpanded={isExpanded}>
            <TitleWrapper>
              <Text tagName="blockquote" variant="hed72Hero" color="blue3">
                {isExpanded ? testimonialData.title + testimonialData.readMoreContent : testimonialData.title}
              </Text>
              {testimonialData?.readMoreContent && toggleExpanded && (
                <StyledReadMore role="button" onClick={toggleExpanded}>
                  <Text variant="dek15" style={{ fontWeight: 'bold' }} color="blue4" tagName="span">
                    {isExpanded ? t('seeLess') : t('readMore')}
                  </Text>
                  <ChevronRightIcon />
                </StyledReadMore>
              )}
            </TitleWrapper>
            <StyledQuotesContainer isExpanded={isExpanded}>
              <Text textAlign="left" tagName="h3" variant="dek20" color="blue3">
                {testimonialData.author}
              </Text>
            </StyledQuotesContainer>
          </TestimonialContent>
        </TestimonialDetails>
      </DetailWrapper>
      <LazyLoadWrapper>
        <TestimonialAsset src={testimonialData.imagePath} />
      </LazyLoadWrapper>
    </TestimonialContainer>
  );
};

export default TestimonialCarouselItem;
